import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'
import { Grid, Box } from '@chatterbug/aaron'
import StatItem from 'src/ui/StatItem/StatItem'
import VerticalDivider from 'src/ui/VerticalDivider/VerticalDivider'

import StatItemProgress from './subcomponents/StatItemProgress/StatItemProgress'
import { liveLessonIcon, timeIcon } from './assets'

const AchievementsLiveLessonsStats = ({
  liveLessonCount,
  hoursCount,
  exerciseTakenCount,
  exerciseGoodCount,
  allExercisesCount,
}) => {
  return (
    <Grid
      boxShadow="overlay"
      borderRadius="1x"
      minWidth={250}
      p={{ _: '2x', tablet: '29px' }}
      pl={{ _: null, tablet: 42 }} // figma
      gridTemplateColumns={{
        _: 'repeat(2, 1fr)',
        tabletWide: 'repeat(4, 1fr)',
      }}
      gridGap="4x"
    >
      <StatItem
        title={t('Live Lessons')}
        number={liveLessonCount}
        icon={liveLessonIcon}
        label={t('total')}
      />
      <StatItem
        title={t('Total Learning')}
        number={hoursCount}
        icon={timeIcon}
        label={t('Hours learning')}
        Divider={() => {
          return (
            <Box display={{ _: 'flex', tabletWide: 'flex' }} mr="3x">
              <VerticalDivider />
            </Box>
          )
        }}
      />
      <StatItemProgress
        title={t('Exercises')}
        progressAchieved={exerciseTakenCount}
        progressTotal={allExercisesCount}
        // illustration / dolfin regular
        progressBackgroundColor={'#C4EEF8'}
        // illustration / dolfin
        progressBarColor={'#5ECCED'}
        label={t('taken')}
        Divider={() => {
          return (
            <Box display={{ _: 'none', tabletWide: 'flex' }} mr="3x">
              <VerticalDivider />
            </Box>
          )
        }}
      />
      <StatItemProgress
        title={t('Exercises')}
        progressAchieved={exerciseGoodCount}
        progressTotal={allExercisesCount}
        /* illustration / octopus regular */
        progressBackgroundColor={'#E2D7FC'}
        /* illustration / octopus */
        progressBarColor={'#AB8AEA'}
        label={t('feeling good')}
        Divider={() => {
          return (
            <Box display={{ _: 'flex', tabletWide: 'flex' }} mr="3x">
              <VerticalDivider />
            </Box>
          )
        }}
      />
    </Grid>
  )
}

AchievementsLiveLessonsStats.propTypes = {
  liveLessonCount: PropTypes.number.isRequired,
  hoursCount: PropTypes.number.isRequired,
  exerciseTakenCount: PropTypes.number.isRequired,
  exerciseGoodCount: PropTypes.number.isRequired,
  allExercisesCount: PropTypes.number.isRequired,
}

export default AchievementsLiveLessonsStats
